<template>
    <span class="tiptap-inline-blank d-inline-flex align-items-center bg-light border rounded">
        <small class="blank-id text-muted">
            {{blank_id}}.
        </small>

        ___

        <!-- <span v-if="answer">
            {{answer}}
        </span>
        <span v-else>
            ___
        </span> -->
    </span>
</template>

<style lang="scss">
.tiptap-inline-blank {
    margin-top: -1px;
    margin-bottom: -1px;
    user-select: none;
    .blank-id {
        line-height: normal;
    }
}
</style>

<script>
export default {
    name: 'Blank',
    data: () => ({

    }),
    props: ['node', 'updateAttrs', 'view'],
    components: {

    },
    computed: {
        blank_id: {
            get () {
                return this.node.attrs.blank_id
            },
            set (blank_id) {
                // we cannot update `blank_id` itself because `this.node.attrs` is immutable
                this.updateAttrs({
                    blank_id,
                })
            },
        },
        answer: {
            get () {
                return this.node.attrs.answer
            },
            set (answer) {
                this.updateAttrs({
                    answer,
                })
            },
        }
    },
    watch: {

    },
    methods: {
    },
    mounted () {

    }
}
</script>
